export const es = {
    toLoginAfterConfirmTitle: `Redirigiendo al inicio de sesión...`,
    toLoginAfterConfirmDescription: `Ahora puedes iniciar sesión. Redirigiendo a la página de inicio de sesión...`,
    toLoginAfterResetTitle: `Contraseña restablecida`,
    toLoginAfterResetDescription: `Ahora puedes iniciar sesión con tu nueva contraseña. Redirigiendo a la página de inicio de sesión...`,
    toResendConfirmationTitle: `Redirigiendo a las opciones de confirmación de correo...`,
};
//# sourceMappingURL=es.js.map